export default __webpack_public_path__ + "static/media/down-arrow.1b8c4c4a.svg";